<template>
  <div class="profileView">
    <v-container class="responsive-height custom-container">
      <v-row dense>
        <v-col cols="12">
          <v-card flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'" class="my-profile">
            <v-card-actions class="pl-5 align-start py-1">
              <v-icon class="mt-4" color="#708AA7">mdi mdi-account-check-outline</v-icon>
              <v-card-text class="px-0 py-0">
                <v-card-title :style="{
                  color:
                    client?.user_doc_status === 'Verified'
                      ? '#1DE9B6'
                      : client?.user_doc_status === 'Pending'
                        ? '#F9A825'
                        : '#F44336',
                }">Profile {{ client?.user_doc_status }}</v-card-title>
                <v-card-subtitle>Verification Status</v-card-subtitle>
              </v-card-text>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card class="verification-card" flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'">
            <v-card-actions class="justify-space-between px-0">
              <v-card-title class="pl-1">
                <v-icon class="pr-5" color="#708AA7">mdi mdi-account-outline</v-icon>Identity Verification
              </v-card-title>
            </v-card-actions>

            <!-- IDENTITY VERIFICATION -->
            <v-card-subtitle class="text-center">
              <span class="d-block">Upload national id, passport, or driver's license.</span>
              Accepted formats: PNG, JPG, JPEG, or PDF.
            </v-card-subtitle>
            <v-card-text class="text-center">
              <vue-dropzone ref="identityVerification" id="customdropzone" :options="dropzoneOptions"
                @vdropzone-success="identityVerificationFileUpload"></vue-dropzone>
              <div class="dropzone-content">
                <v-icon large class="mb-3" color="#708AA7">mdi mdi-tray-arrow-up</v-icon>
                <p class="mb-0">Drop File Here or <strong>Browse</strong></p>
                <span>File size max 1MB</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card class="verification-card" flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'">
            <v-card-actions class="justify-space-between px-0">
              <v-card-title class="pl-1">
                <v-icon class="pr-5" color="#708AA7">mdi mdi-home-lightning-bolt-outline</v-icon>Residence Verification
              </v-card-title>
            </v-card-actions>
            <!-- RESIDENCE VERIFICATION -->
            <v-card-subtitle class="text-center">
              <span class="d-block">Upload documents for residential address verification.</span>Accepted formats: PNG,
              JPG,
              JPEG, or PDF.
            </v-card-subtitle>
            <v-card-text class="text-center">
              <vue-dropzone ref="residenceVerification" id="customdropzone" :options="dropzoneOptions"
                @vdropzone-success="residenceVerificationFileUpload"></vue-dropzone>
              <div class="dropzone-content">
                <v-icon large class="mb-3" color="#708AA7">mdi mdi-tray-arrow-up</v-icon>
                <p class="mb-0">Drop File Here or <strong>Browse</strong></p>
                <span>File size max 1MB</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card v-for="(data, index) in documentInfo?.identityVerificationDocuments" :key="index" flat tile
            :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'" class="listing-upload">
            <v-row no-gutters justify="space-between" align="center">
              <v-col cols="4">
                <v-card-title>Date & Time</v-card-title>
                <v-card-subtitle>{{
                  formatMySQLDate(data?.created_at)
                }}</v-card-subtitle>
              </v-col>
              <v-col cols="4">
                <v-card-title class="comment-title">Comment</v-card-title>
                <v-dialog transition="scale-transition" origin="center center" max-width="554"
                  content-class="deposit-withdraw-popup" v-model="commentdialog[data.id]">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text elevation="0" class="text-capitalize pa-0 see-details-btn" v-bind="attrs" v-on="on"
                      @click="openIdentityComment(data)">See Details</v-btn>
                  </template>
                  <template>
                    <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                      <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'"
                        @click="closeIdentityComment(data)" style="
                          position: absolute;
                          top: 1rem;
                          right: 1rem;
                          z-index: 1;
                        ">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-card-title class="rounded-0">Comment</v-card-title>

                      <ol style="list-style-type: none">
                        <li>
                          {{ data?.comment || "N/A" }}
                        </li>
                      </ol>
                    </v-card>
                  </template>
                </v-dialog>
              </v-col>
              <v-col cols="3">
                <v-card-title class="d-block">Status</v-card-title>
                <v-card-subtitle class="approved-text">{{
                  data?.status
                }}</v-card-subtitle>
              </v-col>
              <v-col cols="1">
                <v-dialog v-if="isImage(data?.document_url)" max-width="554" v-model="dialog[data.id]">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn elevation="0" v-bind="attrs" v-on="on" class="icon-btn"
                      @click="openIdentityImagePreview(data)">
                      <v-icon color="greenMain">
                        <template> mdi mdi-file-image-outline </template>
                      </v-icon>
                    </v-btn>
                  </template>
                  <template>
                    <v-card class="rounded-0 bg-transparent" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                      <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'"
                        @click="closeIdentityImagePreview(data)" style="
                          position: absolute;
                          top: 1rem;
                          right: 1rem;
                          z-index: 1;
                        ">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-img class="white--text align-end" :src="imageIdentityToPreview"></v-img>
                    </v-card>
                  </template>
                </v-dialog>
                <v-btn v-else elevation="0" v-bind="attrs" v-on="on" class="icon-btn"
                  @click="openIdentityImagePreview(data)">
                  <v-icon color="greenMain">
                    <template> mdi mdi-file</template>
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="12" cols="12">
          <v-card v-for="(
              data, index
            ) in documentInfo?.residenceVerificationDocuments" :key="index" flat tile
            :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'" class="listing-upload">
            <v-row no-gutters justify="space-between" align="center">
              <v-col cols="4">
                <v-card-title>Date & Time</v-card-title>
                <v-card-subtitle>{{
                  formatMySQLDate(data?.created_at)
                }}</v-card-subtitle>
              </v-col>
              <v-col cols="4">
                <v-card-title class="comment-title">Comment</v-card-title>
                <v-dialog transition="scale-transition" origin="center center" max-width="554"
                  content-class="deposit-withdraw-popup" v-model="commentdialog[data.id]">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text elevation="0" class="text-capitalize pa-0 see-details-btn" v-bind="attrs" v-on="on"
                      @click="openResidenceComment(data)">See Details</v-btn>
                  </template>
                  <template>
                    <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                      <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'"
                        @click="closeResidenceComment(data)" style="
                          position: absolute;
                          top: 1rem;
                          right: 1rem;
                          z-index: 1;
                        ">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-card-title class="rounded-0">Comment</v-card-title>

                      <ol style="list-style-type: none">
                        <li>
                          {{ data?.comment || "N/A" }}
                        </li>
                      </ol>
                    </v-card>
                  </template>
                </v-dialog>
              </v-col>
              <v-col cols="3">
                <v-card-title class="d-block">Status</v-card-title>
                <v-card-subtitle class="approved-text">{{
                  data?.status
                }}</v-card-subtitle>
              </v-col>
              <v-col cols="1">
                <v-dialog v-if="isImage(data?.document_url)" max-width="554" v-model="dialog[data.id]">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn elevation="0" v-bind="attrs" v-on="on" class="icon-btn"
                      @click="openResidenceImagePreview(data)">
                      <v-icon color="greenMain">
                        <template> mdi mdi-file-image-outline </template>
                      </v-icon>
                    </v-btn>
                  </template>
                  <template>
                    <v-card class="rounded-0 bg-transparent" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                      <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'"
                        @click="closeResidenceImagePreview(data)" style="
                          position: absolute;
                          top: 1rem;
                          right: 1rem;
                          z-index: 1;
                        ">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-img class="white--text align-end" :src="imageResidenceToPreview"></v-img>
                    </v-card>
                  </template>
                </v-dialog>
                <v-btn v-else elevation="0" v-bind="attrs" v-on="on" class="icon-btn"
                  @click="openResidenceImagePreview(data)">
                  <v-icon color="greenMain">
                    <template> mdi mdi-file</template>
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { PROFILE__ACTIONS, REGISTERUSERDETAILS__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { formatMySQLDate } from "@/_helpers/formateDate";

export default {
  name: "profileVerify",
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      pdfImage: window.location.origin + "/static/images/pdf.png",
      dragging: false,
      dropzoneOptions: {
        acceptedFiles: "image/*, application/pdf",
        url: "https://httpbin.org/post",
        thumbnailWidth: 100,
        maxFilesize: 1024,
        headers: { "My-Awesome-Header": "header value" },
        maxFiles: 1,
        addRemoveLinks: true,
      },
      dialog: {},
      commentdialog: {},
      imageIdentityToPreview: "",
      imageResidenceToPreview: "",
      id: null,
    };
  },
  computed: {
    ...mapState("profile", ["client", "documentInfo"]),
  },
  methods: {
        //formatMySQLDate is needed for timeformat
    formatMySQLDate,
    ...mapActions("profile", [
      PROFILE__ACTIONS.GETPROFILE,
      PROFILE__ACTIONS.UPLOADDOCUMENT,
    ]),
    ...mapActions("reguserdetails", [REGISTERUSERDETAILS__ACTIONS.USERDOCUMENTS]),

    async identityVerificationFileUpload(file) {
      if (!file) {
        toast.error("Please select a file to upload!");
        this.$refs.identityVerification.removeFile(file);
        return;
      }

      if (file.size > 3 * 1024 * 1024) {
        toast.error("File size should be less than 3MB");
        this.$refs.identityVerification.removeFile(file);
        return;
      }

      const allowedFileTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
        "application/pdf",
      ];

      if (!allowedFileTypes.includes(file.type)) {
        toast.error("Invalid file format. Upload JPG, JPEG, PNG, PDF only.");
        this.$refs.identityVerification.removeFile(file);
        return;
      }

      const formData = new FormData();
      formData.append("iFile", file);
      formData.append("client_account_id", this.id);

      this[PROFILE__ACTIONS.UPLOADDOCUMENT](formData);
      await Promise.all([
        this[REGISTERUSERDETAILS__ACTIONS.USERDOCUMENTS](this.id),
        this[PROFILE__ACTIONS.GETPROFILE](this.id),
      ]);
      this[REGISTERUSERDETAILS__ACTIONS.USERDOCUMENTS](this.id)
      this[PROFILE__ACTIONS.GETPROFILE](this.id)
    },

    async residenceVerificationFileUpload(file) {
      if (!file) {
        toast.error("Please select a file to upload!");
        this.$refs.residenceVerification.removeFile(file);
        return;
      }

      if (file.size > 3 * 1024 * 1024) {
        toast.error("File size should be less than 3MB");
        this.$refs.residenceVerification.removeFile(file);
        return;
      }

      const allowedFileTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
        "application/pdf",
      ];

      if (!allowedFileTypes.includes(file.type)) {
        toast.error("Invalid file format. Upload JPG, JPEG, PNG, PDF only.");
        this.$refs.residenceVerification.removeFile(file);
        return;
      }

      const formData = new FormData();
      formData.append("rFile", file);
      formData.append("client_account_id", this.id);

      this[PROFILE__ACTIONS.UPLOADDOCUMENT](formData);
      await Promise.all([
        this[REGISTERUSERDETAILS__ACTIONS.USERDOCUMENTS](this.id),
        this[PROFILE__ACTIONS.GETPROFILE](this.id),
      ]);
      this[REGISTERUSERDETAILS__ACTIONS.USERDOCUMENTS](this.id)
      this[PROFILE__ACTIONS.GETPROFILE](this.id)
    },

    isImage(url) {
      const imageExtensions = [".jpg", ".jpeg", ".png", ".webp"];
      return imageExtensions.some((ext) => url.toLowerCase().endsWith(ext));
    },

    openIdentityImagePreview(item) {
      this.imageIdentityToPreview = item?.document_url;
      if (this.isImage(item?.document_url)) {
        this.showDialog(item);
      } else {
        window.open(item?.document_url, "_blank");
      }
    },

    openResidenceImagePreview(item) {
      this.imageResidenceToPreview = item?.document_url;
      if (this.isImage(item?.document_url)) {
        this.showDialog(item);
      } else {
        window.open(item?.document_url, "_blank");
      }
    },

    openResidenceComment(item) {
      this.$set(this.commentdialog, item.id, true);
    },
    closeResidenceComment(item) {
      this.$set(this.commentdialog, item.id, false);
    },
    openIdentityComment(item) {
      this.$set(this.commentdialog, item.id, true);
    },
    closeIdentityComment(item) {
      this.$set(this.commentdialog, item.id, false);
    },

    showDialog(item) {
      if (this.isImage(item.document_url)) {
        this.$set(this.dialog, item.id, true);
      } else {
        window.open(item.document_url, "_blank");
      }
      this.imageToPreview = item;
    },

    closeIdentityImagePreview(item) {
      this.imageIdentityToPreview = "";
      this.$set(this.dialog, item.id, false);
    },

    closeResidenceImagePreview(item) {
      this.imageResidenceToPreview = "";
      this.$set(this.dialog, item.id, false);
    },
  },
  async mounted() {
    const id = this.$route.query.id;
    this.id = this.$route.query.id;
    this[PROFILE__ACTIONS.GETPROFILE](id);
    this[REGISTERUSERDETAILS__ACTIONS.USERDOCUMENTS](id);
  },
};
</script>
